// app/javascript/dashboard/routes/dashboard/settings/emailTemplates/builder/thumbnail.js
// Miniatura da galeria: o HTML da prévia (servidor) desenhado num iframe
// escondido de 600px e fotografado com html-to-image (PNG). O servidor não
// gera miniatura.
import { toPng } from 'html-to-image';

export const THUMB_WIDTH = 600;
export const THUMB_TIMEOUT = 10000;
const MAX_HEIGHT = 2400;
const BLANK_GIF =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

const waitImages = doc =>
  Promise.all(
    [...doc.images].map(img =>
      img.complete
        ? null
        : new Promise(resolve => {
            img.onload = resolve; // eslint-disable-line no-param-reassign
            img.onerror = resolve; // eslint-disable-line no-param-reassign
          })
    )
  );

async function capture(html, frame, { width, render, settle }) {
  const doc = frame.contentDocument;
  doc.open();
  doc.write(html);
  doc.close();
  if (settle)
    await new Promise(resolve => {
      setTimeout(resolve, settle);
    });
  await waitImages(doc);
  const height = Math.min(doc.documentElement.scrollHeight || 800, MAX_HEIGHT);
  return render(doc.body, {
    width,
    height,
    pixelRatio: 1,
    cacheBust: false,
    backgroundColor: '#ffffff',
    imagePlaceholder: BLANK_GIF,
  });
}

export async function makeThumbnail(
  html,
  {
    width = THUMB_WIDTH,
    render = toPng,
    settle = 300,
    timeout = THUMB_TIMEOUT,
  } = {}
) {
  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  // Sem scripts: só mesma origem, para poder ler o documento e fotografar.
  frame.setAttribute('sandbox', 'allow-same-origin');
  // Fora da tela (não é estilo de componente: o iframe some logo depois).
  Object.assign(frame.style, {
    position: 'fixed',
    left: '-10000px',
    top: '0',
    width: `${width}px`,
    height: '10px',
    border: '0',
  });
  document.body.appendChild(frame);
  let timer;
  try {
    const limit = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error('thumbnail timeout')), timeout);
    });
    return await Promise.race([
      capture(html, frame, { width, render, settle }),
      limit,
    ]);
  } finally {
    clearTimeout(timer);
    frame.remove();
  }
}
